import styles from "./myFooter.module.scss";
import Link from "next/link";
import DownBtn from "../DownBtn";
import { useEffect, useState } from 'react'
import { getExchangeCode } from '../../../pages/api/getCode'
import utils from '../../../utils'
import Clipboard from 'clipboard'
import { H5Tracer } from '../../../pages/api/H5Tracer';
let clb = null
const MyFooter = () => {
  const footArr = [
    {
      title: "ABOUT US",
      list: [
        {
          title: "Contact",
          path: "/contact.html",
        },
        {
          title: "FAQ",
          path: "http://blog.dingtone.me/en/faq/",
        },
        {
          title: "Support",
          path: "/support.html",
        },
        {
          title: "Our Users",
          path: "/ourusers.html",
        },
        {
          title: "Brand Ambassador",
          path: "/brand.html",
        },
      ],
    },
    {
      title: "FOLLOW US",
      list: [
        {
          title: "Blog",
          path: "http://blog.dingtone.me/en/",
        },
        {
          title: "Twitter",
          path: "http://www.twitter.com/dingtone",
        },
      ],
    }
  ];
  const [rewardCode, setRewardCode] = useState('');
  // 两个生成兑换码的着落页
  useEffect(()=>{
    if(utils.canShowRedeemCode()) {
      setTimeout(async () => {
        if(!clb) {  
          clb = new Clipboard(document.querySelector('.' + styles.redeem + '>div'))
          const res = await getExchangeCode();
          try {
            const code = res.data.data || ''
            setRewardCode(code);
            
            H5Tracer.invoke("getCode", {
              code,
              location: window.location.href,
              refer: document.referrer
            }, { label: "code", value: code })

            clb.on('success', (e) => {
              // window.gtag("event", "Click", {
              //   event_category: "Copy_Code",
              //   event_action: window.location.href,
              //   event_label: "Redeem_Code"
              // })
              utils.toast('Successfully copied ! Go to APP to redeem reward.')
              e.clearSelection()
              console.log("I copied this string: " + rewardCode)

              H5Tracer.invoke("cpCodeSuccess", {
                code,
                location: window.location.href,
                refer: document.referrer
              }, { label: "code", value: code })
            })
            clb.on('error', function (ex) {
              console.log("I copied failed: " + JSON.stringify(ex))

              H5Tracer.invoke("cpCodeFailed", {
                code,
                location: window.location.href,
                refer: document.referrer
              }, { label: "code", value: code })
            })
          } catch(e) {
            console.log(e)
          }
        }
      })
    }
  },[])
  return (
    <footer className={styles.footer}>
      <div className="main">
        <div className={styles.top}>
          <div className={styles.left}>
            <Link href="/">
              <a className={styles.logo}>
                <img className={styles.logo} src="/img/nav_logo.png" alt="logo" />
                <img className={styles.logoBg} src="/img/nav_logo_bg.png" alt="logo" />
              </a>
            </Link>
            <div className={styles.redeem}>
              <div data-clipboard-text={rewardCode} style={{ display: rewardCode ? "block" : "none" }}>
                Get the redeem code &nbsp;
                <span style={{ color:'yellow' }}>{rewardCode}</span>
                <img style={{marginLeft:'5px'}} src="/images/copy@1x.png" alt="copy" />
              </div>
            </div>
            <p>
              Cheap international phone calls to United States, India,
              Bangladesh, Pakistan, Mexico, Philippines, Jamaica, Nepal,
              Nigeria, Saudi Arabia, Egypt, China, Brazil, United Kingdom,
              United Arab Emirates...
            </p>

            <DownBtn use="small"></DownBtn>
          </div>

          <div className={styles.right}>
            {footArr.map((item, index) => (
              <ul key={index}>
                <li>
                  <h3>{item.title}</h3>
                  <ul>
                    {item.list.map((itm, idx) => (
                      <li key={idx}>
                        <Link href={itm.path}>
                          <a>{itm.title}</a>
                        </Link>
                      </li>
                    ))}
                  </ul>
                </li>
              </ul>
            ))}
          </div>
        </div>
        <div className={styles.bottom}>
          <div className={styles.cr}>
            © 2021{" "}
            <Link href="/">
              <a>Dingtone</a>
            </Link>
          </div>
          <div className="navList">
            <ul>
              <li>
                <Link href="/privacy_policy.html">
                  <a>Privacy Policy</a>
                </Link>
              </li>
              <li>
                <span>|</span>
              </li>
              <li>
                <Link href="/Terms_of_Service.html">
                  <a>Terms of Service</a>
                </Link>
              </li>
              <li>
                <span>|</span>
              </li>
              <li>
                <Link href="/sitemap.xml">
                  <a>Site Map</a>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default MyFooter;
